/* remy-pdp.js -- HAND-AUTHORED (theme-src/, 2026-10-16). Store-only; script.js
   is a frozen /mockup copy, so PDP additions live here.

   BUY IT NOW: adds the SELECTED size (the active .size-chip, same source as Add
   to Bag) to Shopify's real cart through /cart/add.js, then goes to /checkout.
   Checkout therefore shows the whole bag: what was already in it plus this
   item. (A cart permalink /cart/<id>:1 would replace the bag, so it is not used.)
   Double taps are ignored while a request is in flight, and both buy buttons are
   disabled with aria-busy until it settles. */
(function () {
  'use strict';
  var btn = document.querySelector('[data-buy-now]');
  if (!btn) return;
  var root = btn.closest('[data-product]');
  if (!root) return;
  var add = root.querySelector('[data-add-to-cart]');
  var msg = root.querySelector('[data-add-msg]');
  var label = btn.textContent;
  var busy = false;

  function say(text) {
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.className = 'pdp__addmsg pdp__addmsg--err';
  }
  function setBusy(on) {
    busy = on;
    btn.disabled = on;
    if (add) add.disabled = on;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Please wait…'; }
    else { btn.removeAttribute('aria-busy'); btn.textContent = label; }
  }

  btn.addEventListener('click', function () {
    if (busy) return;
    var chip = root.querySelector('.size-chip.is-active:not([disabled])');
    var id = chip && parseInt(chip.getAttribute('data-variant-id'), 10);
    if (!id) { say('Choose a size first.'); return; }

    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not start checkout. Please try again.');
        });
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        say(err.message || 'Could not start checkout. Please try again.');
        setBusy(false);
      });
  });

  /* Back from checkout out of the bfcache: the button must not stay stuck. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });
}());
